import { BaseDataElement } from './base-data-element.model';

export class DateTimeDataElement extends BaseDataElement {

}
